import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  appBarSearch: {
    marginBottom: "1rem",
    display: "flex",
    padding: "16px",
    borderRadius: 15,
  },
  pagination: {
    borderRadius: 15,
    marginTop: "1rem",
    padding: "16px",
  },
  gridContainer: {
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
}));
